import parents from './parents';
import middle from './middle';
import children from './children';
import { flat } from '../utils';
const sequence = [parents, middle, children];
function toConnectors(families) {
    return (fn) => fn(families);
}
export default (families) => {
    return sequence.map(toConnectors(families)).reduce(flat);
};
//# sourceMappingURL=index.js.map